<template>
  <v-card v-if="report && report.length" class="mt-5 py-3">
    <v-data-table
      v-if="report.length"
      :headers="headers"
      :items="report"
      loading-text="Загрузка..."
      no-data-text="Ничего не найдено"
      hide-default-footer
      dense
      disable-pagination
    >
      <template #[`item.actions`]="{ item }">
        <v-btn v-if="item.uid" icon :to="{ name: 'SpeechAnalysisCall', params: {uid: item.uid} }" target="_blank">
          <v-icon dense>mdi-dock-window</v-icon>
        </v-btn>
      </template>

    </v-data-table>
  </v-card>
</template>


<script>

export default {
  name: 'HoldReport',
  props: {
    report: {
      type: Array
    },
  },
  data() {
    return {
      headers: [
        { text: 'Имя', value: 'agent'},
        { text: 'Проект', value: 'project'},
        { text: 'Очередь', value: 'queue'},
        { text: 'Дата звонка', value: 'call_date'},
        { text: 'Длительность удержания', value: 'hold'},
        { text: 'КЛН', value: 'kln'},
        { text: 'Комментарий', value: 'comment', sortable: false, },
        { text: 'Просмотр', value: 'actions', sortable: false, },
      ],
    }
  },

}
</script>


<style scoped lang="scss">

</style>